import { type FormEvent, useState } from "react"
import { errorTag } from "../../api.ts"
import { login } from "./session.ts"

const messages: Record<string, string> = {
  InvalidCredentials: "Wrong username or password.",
  TooManyLoginAttempts: "Too many failed attempts. Try again in a few minutes."
}

export function LoginPage() {
  const [username, setUsername] = useState("")
  const [password, setPassword] = useState("")
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  const submit = async (event: FormEvent) => {
    event.preventDefault()
    setBusy(true)
    setError(null)
    try {
      await login(username, password)
    } catch (cause) {
      setError(messages[errorTag(cause)] ?? "Couldn't sign in. Check the connection and try again.")
      setBusy(false)
    }
  }

  return (
    <main className="login">
      <form className="login-card" onSubmit={submit}>
        <h1>Trader</h1>
        <label>
          Username
          <input autoFocus autoComplete="username" value={username} onChange={(e) => setUsername(e.target.value)} />
        </label>
        <label>
          Password
          <input
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </label>
        {error && <p className="form-error" role="alert">{error}</p>}
        <button type="submit" disabled={busy || username === "" || password === ""}>
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </main>
  )
}
